import { Component, OnInit, OnDestroy } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import * as moment from "moment-timezone";
import { DatePipe } from "@angular/common";
import { ReportGridService } from "../services/report-grid.service";

@Component({
  selector: "app-checked-in-patient",
  templateUrl: "./checked-in-patient.component.html",
})
export class CheckedInPatientComponent implements OnInit, OnDestroy {
  rowsData: any[] = [];
  columnsData: any = [];
  row: any = {};
  destroyComponent: any = {};
  totalItems = 0;
  maxSize = 10;
  maxSizeItem = 10;
  pageOrder: any = {};
  currentPage = 1;
  page: number;
  errorMessage = "";
  checkinPrintList: any;
  currentDate: any = new Date();
  constructor(
    private api: AppService,
    private supportService: SupportService,
    private datepipe: DatePipe,
    private reportGrid: ReportGridService
  ) {}

  ngOnInit() {
    this.getRowsData();
    this.generate();
    this.getColumnOrder();
    this.getCheckinDatePrintList();
  }
  private getRowsData() {
    this.rowsData = [
      {
        title: "First Name",
        sorting: true,
        name: "patientFirstName",
        dateFitler: false,
      },
      {
        title: "Last Name",
        sorting: true,
        name: "patientLastName",
        dateFitler: false,
      },
      {
        title: "Date Booked",
        sorting: true,
        name: "createdOn",
        dateFitler: true,
      },
      {
        title: "Date of Service",
        sorting: true,
        name: "scheduledOnStr",
        dateFitler: true,
      },
      {
        title: "Checked In Time",
        sorting: true,
        name: "checkInOn",
        dateFitler: false,
      },
      {
        title: "Procedure",
        sorting: false,
        name: "procedureName",
        dateFitler: false,
      },
      {
        title: "Heard About?",
        sorting: false,
        name: "hearedAboutUs",
        dateFitler: false,
      },
    ];
    this.row = {
      param1: "patientFirstName",
      param2: "patientLastName",
      param3: "createdOn",
      param4: "scheduledOnStr",
      param5: "checkInOn",
      param6: "procedureName",
      param7: "hearedAboutUs",
    };
    this.pageOrder = {
      type: "checkedin",
      pageNumber: 1,
      pageRecord: this.maxSizeItem,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "checkInOn",
      sortType: "desc",
      search: "",
    };
  }

  getCheckinDatePrintList() {
    const pageOrder = this.clearCacheItem("savePdf");
    const param = pageOrder;
    param["offsetmin"] = new Date().getTimezoneOffset();
    this.api.etScheduleByTypeCheckin(param).subscribe((res: any) => {
      this.checkinPrintList = [];
      if (res && res.entity) {
        this.checkinPrintList = res.entity;
      }
    });
  }

  private getColumnData(param?, blur?) {
    this.api.etScheduleByTypeCheckin(param).subscribe(
      (res: any) => {
        this.columnsData = [];
        if (blur && blur === "blur") {
          this.currentPage = 1;
        }
        if (res && res.entity) {
          this.totalItems = res["count"];
          res.entity.forEach((obj) => {
            if (obj && obj["patientCheckIn"]) {
              const param = this.getParamData(obj);
              this.columnsData.push(param);
            }
          });
        }
      },
      (err) => {
        if (err.error.error === "invalid_token") {
          this.api.sessionOut(err);
        }
      }
    );
  }
  private getParamData(obj) {
    const param: any = this.reportGrid.buildRowParams(this, obj);
    if (param.param3) {
      param.param3 = this.convertutctolocal(param.param3, "");
    }
    if (param.param5) {
      param.param5 = this.convertutctolocal(param.param5, "time");
    }
    return param;
  }

  convertutctolocal(value, type) {
    return this.reportGrid.convertutctolocal(this.datepipe, value, type);
  }

  setLocaldatetime(value: any, date: any, time: any): string {
    let now_utc1 = "0";
    let local;
    if (date && time) {
      const now1 = new Date(date + " " + time);
      local = moment(now1)
        .subtract(this.currentDate.getTimezoneOffset(), "m")
        .toDate();
      now_utc1 =
        local.getFullYear() +
        "-" +
        this.chkLength(local.getMonth() + 1) +
        "-" +
        this.chkLength(local.getDate()) +
        " " +
        this.chkLength(local.getHours()) +
        ":" +
        this.chkLength(local.getMinutes()) +
        ":" +
        this.chkLength(local.getSeconds());
    }
    return now_utc1;
  }

  convert24to12(value): string {
    let timevalue = "";
    let time = value.toString().split(" ");
    if (time && time[1]) {
      time = time[1]
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      timevalue = time.join(""); // return adjusted time or original string
    }
    return timevalue;
  }

  chkLength(data) {
    if (data.toString().length == 1) {
      return "0" + data.toString();
    } else {
      return data;
    }
  }

  getFormateTotime(Totime) {
    // Check correct time format and split into components
    if (Totime) {
      const timearry = Totime.toString().split(" ");
      if (timearry.length > 1) {
        let time = timearry[1];
        time = time
          .toString()
          .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
          // If time format correct
          time = time.slice(1); // Remove full string match value
          time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
          time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(""); // return adjusted time or original string
      }
      return "-";
    }
    return "-";
  }

  private getColumnOrder() {
    this.reportGrid.getColumnOrder(this);
  }
  ngOnDestroy() {
    this.reportGrid.ngOnDestroy(this);
  }
  pageChanged(event) {
    this.reportGrid.pageChanged(this, event);
  }
  generate() {
    this.reportGrid.generate(this);
  }
  savePdf(ev) {
    const pageOrder = this.clearCacheItem("savePdf");
    const param = pageOrder;
    param["offsetmin"] = new Date().getTimezoneOffset();
    this.api.getScheduleReportByType(param).subscribe((res: any) => {
      if (res && res["entity"] && res["entity"]["pdfFileURL"]) {
        this.api.savePdf(res["entity"]["pdfFileURL"]);
      } else {
        this.errorMessage = "No record found";
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
      }
    });
  }
  private clearCacheItem(pdf?) {
    return {
      type: "checkedin",
      pageNumber: 0,
      pageRecord: 0,
      patientType: "all",
      tcId: localStorage.getItem("testCenterId"),
      startDate: "",
      endDate: "",
      sortColumn: "checkInOn",
      sortType: "desc",
      search: this.pageOrder["search"] ? this.pageOrder["search"] : "",
    };
  }
  blurOnChange(ev) {
    this.reportGrid.blurOnChange(this, ev);
    this.getCheckinDatePrintList();
  }
}
